import { buildApiUrl, fetchJSON, validateRequiredParams } from './crmApi';

export interface DealStageInput {
  organization_id: string;
  name: string;
  position: number;
}

export interface DealStage extends DealStageInput {
  id: string;
  created_at: string;
}

const dealStagesService = {
  async list(organization_id: string): Promise<{ data: DealStage[] }>{
    validateRequiredParams({ organization_id }, ['organization_id'], {
      service: 'dealStagesService.list'
    });
    const url = buildApiUrl('/api/crm/deal-stages', { organization_id });
    return fetchJSON(url, {
      description: 'List deal stages',
      context: { organization_id }
    });
  },
  async create(payload: DealStageInput): Promise<{ data: DealStage }>{
    validateRequiredParams(payload, ['organization_id', 'name', 'position'], {
      service: 'dealStagesService.create'
    });
    const url = buildApiUrl('/api/crm/deal-stages');
    return fetchJSON(url, {
      method: 'POST',
      body: payload,
      description: 'Create deal stage',
      context: { organization_id: payload.organization_id }
    });
  },
  async update(id: string, payload: Partial<DealStageInput> & { organization_id: string }): Promise<{ data: DealStage }>{
    validateRequiredParams({ id, ...payload }, ['id', 'organization_id'], {
      service: 'dealStagesService.update'
    });
    const url = buildApiUrl(`/api/crm/deal-stages/${encodeURIComponent(id)}`);
    return fetchJSON(url, {
      method: 'PUT',
      body: { ...payload, id },
      description: 'Update deal stage',
      context: { id, organization_id: payload.organization_id }
    });
  },
  async remove(id: string, organization_id: string): Promise<{ success: boolean }>{
    validateRequiredParams({ id, organization_id }, ['id', 'organization_id'], {
      service: 'dealStagesService.remove'
    });
    const url = buildApiUrl(`/api/crm/deal-stages/${encodeURIComponent(id)}`, { organization_id });
    return fetchJSON(url, {
      method: 'DELETE',
      description: 'Delete deal stage',
      context: { id, organization_id }
    });
  }
};

export default dealStagesService;
